import React from 'react';
import PageHeader from '../components/PageHeader';
import ContactSection from '../components/ContactSection';
import CTABoxes from '../components/CTABoxes';

const ContactPage = () => {
  return (
    <>
      <PageHeader
        eyebrow="Get In Touch"
        title="Contact AA Plumbing & Roofing"
        description="Ready for a quote? Fill out the form below or give us a call — we'll get back to you fast."
      />
      <ContactSection />
      <CTABoxes />
    </>
  );
};

export default ContactPage;
